import { getPageAnalyticsContext } from './outboundLink';
import { GA4_MEASUREMENT_ID } from './ga4Dimensions';

let loadPromise = null;

export const loadGoogleAnalytics = () => {
  if (typeof window === 'undefined') {
    return Promise.resolve();
  }

  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise(resolve => {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`;
    script.onload = () => {
      window.gtag('js', new Date());
      window.gtag('config', GA4_MEASUREMENT_ID, {
        send_page_view: false,
      });
      resolve();
    };
    script.onerror = () => resolve();
    document.head.appendChild(script);
  });

  return loadPromise;
};

export const scheduleGoogleAnalytics = () => {
  if (typeof window === 'undefined') return;

  const load = () => {
    loadGoogleAnalytics();
  };

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(load, { timeout: 4000 });
    return;
  }

  if (document.readyState === 'complete') {
    load();
    return;
  }

  window.addEventListener('load', load, { once: true });
};

export const trackPageView = pagePath => {
  if (typeof window === 'undefined' || !pagePath) return;

  const pageViewParams = {
    ...getPageAnalyticsContext(),
    page_path: pagePath,
  };

  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', pageViewParams);
    return;
  }

  loadGoogleAnalytics().then(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', pageViewParams);
    }
  });
};
